import { useLayoutEffect } from 'react';

export function useAppLoader(message?: string, enabled: boolean = true): void {
  useLayoutEffect(() => {
    if (!enabled) {
      window.hideLoadingSpinner();
      return;
    }

    window.showLoadingSpinner();

    return () => {
      window.hideLoadingSpinner();
    };
  }, [enabled]);

  useLayoutEffect(() => {
    if (enabled && message !== undefined) {
      window.setLoadingMessage(message);
    }
  }, [message, enabled]);
}
